var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('div',{staticClass:"container"},[(_vm.cities)?_c('UserCreateFormComponent',{attrs:{"cities":_vm.cities},on:{"create-user-requested":_vm.onCreateUserRequested}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }